import { updateSessionById } from '@/pages/api/scribeAPI';
import { toast } from '@heidi/design-system/toast';

import { logger } from '@/utils/logger/logger';
import { useMutation, useQueryClient } from '@tanstack/react-query';

// import { type SessionResponse } from '@heidi/session/contracts';
import { GET_SESSION_BY_ID } from '@heidi/session/contracts';

// type Props = {
//   sessionId: string;
// };

export function useMutateUpdateSessionSocketError() {
  const queryClient = useQueryClient();

  return useMutation({
    networkMode: 'offlineFirst',
    retry: 3,
    mutationKey: ['updateSessionSocketError'],
    mutationFn: async (sessionId: string) => {
      return await updateSessionById(sessionId, {
        had_ws_recording_failure: true,
      });
    },
    onMutate: () => {
      // queryClient.setQueryData<SessionResponse>(
      //   [GET_SESSION_BY_ID, { sessionId }],
      //   (oldData) => {
      //     if (!oldData) {
      //       return undefined;
      //     }
      //     const newData: SessionResponse = {
      //       ...oldData,
      //       had_ws_recording_failure: true,
      //     };
      //     return newData;
      //   }
      // );
    },
    onSuccess: (sessionId) => {
      void queryClient.invalidateQueries({
        queryKey: [GET_SESSION_BY_ID, { sessionId }],
      });
    },
    onError: (error) => {
      logger.error('Error:', error);
      toast({
        tone: 'destructive',
        title: 'There was an error updating the session. Please try again.',
        description: error.message,
      });
    },
  });
}
